var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 206,
    width: 172,
    height: 292,
    rx: 6,
    transform: "rotate(-90 29 206)",
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 202,
    x2: 67,
    y2: 30,
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283,
    y1: 202,
    x2: 283,
    y2: 30,
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 142L47 98",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 143,
    width: 45,
    height: 13,
    rx: 4,
    transform: "rotate(-90 295 143)",
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.94 145V106.01H93.52V99.22H130.48V106.01H116.06V145H107.94ZM140.183 145V99.22H169.513V106.08H148.303V117.77H166.293V124.63H148.303V138.14H170.213V145H140.183ZM196.085 145.84C192.865 145.84 189.785 145.257 186.845 144.09C183.905 142.923 181.292 141.267 179.005 139.12L183.765 133.59C185.492 135.13 187.452 136.39 189.645 137.37C191.839 138.303 194.149 138.77 196.575 138.77C199.235 138.77 201.265 138.257 202.665 137.23C204.065 136.157 204.765 134.827 204.765 133.24C204.765 131.887 204.439 130.813 203.785 130.02C203.132 129.18 202.222 128.48 201.055 127.92C199.935 127.36 198.605 126.777 197.065 126.17L190.835 123.44C189.249 122.787 187.685 121.947 186.145 120.92C184.652 119.893 183.415 118.587 182.435 117C181.502 115.413 181.035 113.5 181.035 111.26C181.035 108.833 181.712 106.663 183.065 104.75C184.419 102.79 186.285 101.25 188.665 100.13C191.092 98.9633 193.845 98.38 196.925 98.38C199.725 98.38 202.385 98.9167 204.905 99.99C207.472 101.017 209.712 102.417 211.625 104.19L207.425 109.37C205.885 108.11 204.252 107.153 202.525 106.5C200.845 105.8 198.839 105.45 196.505 105.45C194.359 105.45 192.609 105.917 191.255 106.85C189.902 107.783 189.225 109.113 189.225 110.84C189.225 112.007 189.599 112.963 190.345 113.71C191.092 114.457 192.049 115.11 193.215 115.67C194.429 116.23 195.712 116.767 197.065 117.28L203.085 119.87C205.045 120.617 206.772 121.527 208.265 122.6C209.759 123.673 210.925 125.003 211.765 126.59C212.605 128.13 213.025 130.02 213.025 132.26C213.025 134.733 212.349 136.997 210.995 139.05C209.642 141.103 207.705 142.76 205.185 144.02C202.665 145.233 199.632 145.84 196.085 145.84ZM233.858 145V106.01H219.438V99.22H256.398V106.01H241.978V145H233.858Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 350,
    fill: "white",
    transform: "translate(0 240) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesting);
export default __webpack_public_path__ + "static/media/testing.32bcf9a300a4e4bd402b64b69dc06201.svg";
export { ForwardRef as ReactComponent };